import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { status } = useAuth();

  if (status === 'checking') {
    return (
      <div
        data-testid="admin-auth-loading"
        className="min-h-screen flex items-center justify-center text-muted-foreground"
      >
        <div className="w-8 h-8 border-4 border-primary/30 border-t-primary rounded-full animate-spin" />
      </div>
    );
  }

  if (status !== 'authed') {
    return <Navigate to="/admin-login" replace />;
  }

  return children;
};

export default ProtectedRoute;
